// readCookie comes from general.js. When it isn't present (e.g. serverside rendering,
// or a third-party site that hasn't loaded our cookie helpers), treat the user as logged out.

export function isLoggedIn(): boolean {
    if (!window.readCookie) {
        return false;
    }
    const loggedInCookie = window.readCookie('isLoggedIn');
    return loggedInCookie === 'true';
}

// This can be used for show and hide but there needs to be back end code to do a real auth check
export function isLoggedInOrRemembered(): boolean {
    if (!window.readCookie) {
        return false;
    }
    const loggedInOrRemembered = window.readCookie('headerinfo');
    return !(loggedInOrRemembered == null || loggedInOrRemembered === '');
}
